import React, { FC, useContext } from 'react'

import GlobeIcon from '../../../public/static/icons/globe.svg'
import ListIcon from '../../../public/static/icons/list.svg'
import cx from 'classnames'

import css from './Menu.module.scss'
import { WheretoBuyContext } from '../../../contexts/whereToBuyProvider'

const Menu: FC = () => {
  const { setFilters, filters, setActiveTab, activeTab } =
    useContext(WheretoBuyContext)

  return (
    <div className={css.menu_wrapper}>
      <nav className={css.menu}>
        <button
          type="button"
          onClick={() => {
            setActiveTab('list')
          }}
          className={cx(
            css.menu_link,
            (activeTab === 'list' || !activeTab) && css.active,
          )}
        >
          <ListIcon />
          <span>список</span>
        </button>
        <button
          type="button"
          onClick={() => {
            setActiveTab('map')
          }}
          className={cx(css.menu_link, activeTab === 'map' && css.active)}
        >
          <GlobeIcon />
          <span>карта</span>
        </button>
        <button
          type="button"
          className={cx(
            css.menu_filter,
            !filters.insta && !filters.store && !filters.web && css.active,
          )}
          onClick={() => setFilters({ web: false, insta: false, store: false })}
        >
          все
        </button>
        <button
          type="button"
          className={cx(css.menu_filter, filters.web && css.active)}
          onClick={() => setFilters({ web: true, insta: false, store: false })}
        >
          интернет-магазин
        </button>

        <button
          type="button"
          className={cx(css.menu_filter, filters.store && css.active)}
          onClick={() => setFilters({ web: false, insta: false, store: true })}
        >
          магазин
        </button>
      </nav>
    </div>
  )
}

export default Menu
